import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, isEmail } from "@mantine/form";
import { Button, TextInput, Group, ActionIcon } from "@mantine/core";
import { ReactComponent as BackIcon } from "@/assets/icons/back.svg";
import { errorNotification } from "@/helpers/notifications";
import { AuthApi } from "@/api/auth.api";
import "./PasswordRecovery.css";

const ForgottenPassword: React.FC = () => {
  const navigate = useNavigate();
  const [sent, setSent] = useState(false);

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      email: "",
    },
    validate: {
      email: isEmail("E-mail nije ispravan"),
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    const email = values.email;
    const res = await AuthApi.forgottenPassword(email);
    setSent(true);
    if (!res?.isSuccessful) {
      errorNotification({
        title: "Neočekivana pogreška",
        message: res?.message ?? "Molimo pokušajte ponovno.",
      });
    }
  };

  return (
    <div className="forgotten-password-container">
      <form
        className="forgotten-password-card"
        onSubmit={form.onSubmit(handleSubmit)}
      >
        <div className="forgotten-password-content">
          <Group
            className="cursor-pointer hover:opacity-80"
            onClick={() => navigate("/login")}
          >
            <ActionIcon
              variant="filled"
              size="lg"
              radius="xl"
              className="!bg-[#f4f4f4]"
              aria-label="Back"
            >
              <BackIcon fill="#0B1A29" />
            </ActionIcon>
            <div className="text-[#0b1a29] text-base font-bold">Natrag</div>
          </Group>
          <div className="forgotten-password-title">Zaboravljena lozinka</div>
          {sent ? (
            <div className="max-w-[460px] text-[#515151] text-sm font-medium">
              Link za resetiranje lozinke poslan je na upisanu e-mail adresu.
              Molimo provjerite inbox i nastavite s uputama.
            </div>
          ) : (
            <>
              <div className="max-w-[460px] text-[#515151] text-sm font-medium">
                Za ponovno postavljanje lozinke unesite svoju e-mail adresu i
                pratite upute za kreiranje nove lozinke.
              </div>
              <div className="flex flex-col gap-6">
                <TextInput
                  label="E-mail"
                  placeholder="E-mail adresa"
                  key={form.key("email")}
                  {...form.getInputProps("email")}
                />
              </div>
            </>
          )}
        </div>
        <div className="forgotten-password-button-container">
          <Button
            type="submit"
            variant="filled"
            color="#004a99"
            radius="xl"
            size="md"
            className="flex-1 !h-[3.25rem]"
            disabled={sent}
          >
            Pošalji
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ForgottenPassword;
